var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 438,
    viewBox: "0 0 347 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 438,
    rx: 16,
    fill: "url(#pattern0_1140_2821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1140_2821",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1140_2821",
    transform: "matrix(0.0197226 0 0 0.015625 -0.131124 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1140_2821",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAN5JREFUeF7t2rENwzAMBVFpJQ+UIoO5iPfJSskQV7DQc28QkMy7L8p7r/Vb4fncV3h7rdf7m96v9bcF8AVoAQwoFKoQAkEWoMHSgau2oBwgCAlCgpAgVDBcKSwITQeh575SC0zvYK2/LYAvQAtgQNFghdC0RkGQBViABViABcIK0ODwaa5ugBxwfA4wFTYVNhVOQWj6NFfruxoDQRAEQRAMZ6H8g0LN8iwQ/1SlQRqkQRo8W4PHD0QsgJshN0MJgtNRttY3FgdBEARBECwDkUrhOtCo9VmABViABY62wB/Vp46QBvcE/QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy3);
export default __webpack_public_path__ + "static/media/dummy3.fa71b2e8074b222ceef22cb3be0b2175.svg";
export { ForwardRef as ReactComponent };